<cwt-mailing-header></cwt-mailing-header>
<nz-divider class="m-0"></nz-divider>
<form id="mail-form" [formGroup]="form" [cwtFormSubmit]="form" (formValid)="send($event)">
    <cwt-mail-recipients-input cwtEmail formControlName="emails"></cwt-mail-recipients-input>
    <cwt-mail-template-input required formControlName="template"  [useCases]="useCases" [resolveConstraint]="resolveConstraint"></cwt-mail-template-input>
    <input nz-input nzBorderless required formControlName="subject" [placeholder]="'field.mail-subject' | translate"/>
    <nz-divider class="m-0"></nz-divider>
    <quill-editor borderless [required]="true" [preserveWhitespace]="true" formControlName="content" [placeholder]="'field.mail-content' | translate"></quill-editor>
</form>
<nz-divider class="m-0"></nz-divider>
<cwt-mailing-footer [loading]="loading" formId="mail-form"></cwt-mailing-footer>